import { useCallback, useEffect, useLayoutEffect, useRef } from 'react';

export const useDebounce = (callback, delay) => {
  const timerRef = useRef(null);
  const callbackRef = useRef(callback);

  // Publish only committed render callbacks. Stable callers avoid effect loops,
  // while each invocation still captures the same callback/intent it scheduled.
  useLayoutEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => () => clearTimeout(timerRef.current), [delay]);

  return useCallback((...args) => {
    clearTimeout(timerRef.current);
    const scheduledCallback = callbackRef.current;
    timerRef.current = setTimeout(() => {
      scheduledCallback(...args);
    }, delay);
  }, [delay]);
};
